'use strict';

// TO DO ACCESSIBILITY DEVELOPMENTS

var scrollAnimate = require('../components/scrollAnimate');

$(document).ready(function () {
    var currentUrl = window.location.href;
    var index = currentUrl.lastIndexOf('language=');
    var languageValue = $(this).find('select').val();
    if (index > -1) {
        var temp = currentUrl.slice(index + 9);
        $('.js-dynamicContentSelect option').each((key, elem) => {
            if (temp === elem.value) {
                languageValue = temp;
            }
        });
    }
    $(document).find('.js-dynamicContentLanguage').hide();
    $(document).find('.filter-option-inner-inner').text(languageValue);
    $(document).find('.js-dynamicContentLanguage[data-language-code=' + languageValue + ']').show();
    $('.cc-dynamicContentItems').children().each((key,elem) => {
        if (!elem.hasChildNodes() && elem.attributes.length === 1 && elem.hasAttribute('language')) {
            elem.remove();
        }
    });

    // Carousel Chapter
    $(document).find('.cc-carouselChapters').each(function() {
        const indexCurrent = $(this).find('.cc-carouselChapters__item--current').closest('.slick-slide:not(.slick-cloned)').attr('data-slick-index');
        $(this).find('.cc-carouselChapters__item--current').closest('.slick-slide').addClass('slick-slide--current');
        $(this).find('.cc-carouselChapters__item--previous').closest('.slick-slide').addClass('slick-slide--previous');
        $(this).find('.cc-carouselChapters__slider').slick('slickGoTo', indexCurrent);
    });

    $(document).on('click', '.js-carouselChapterButton', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.cc-carouselChapters__item').toggleClass('cc-carouselChapters__item--open');
    });

    // sync mobile and desktop videos in CO_Image module on orientation change
    if ($('.experience-commerce_assets-CO_Image .cc-image__video').length ) {
        var syncVideos = function(video1, video2, switchPlayingVideo, forceScroll) {
            video2.currentTime = video1.currentTime;
            if (switchPlayingVideo) {
                video1.pause();
                video2.play();
            }

            if (switchPlayingVideo || forceScroll) {
                setTimeout(() => {
                    scrollAnimate($(video2), {center: true});
                }, 500);
            }
        }
        // when entering fullscreen, the same video will be showed even when rotating the screen
        // when exiting fullscreen, switch to the second video if necessary
        $(document).on('fullscreenchange', '.cc-image__video .video-js', function(e) {
            var isFullscreen =$(this).hasClass('vjs-fullscreen');
            $(this).closest('.cc-image__video').toggleClass('cc-image__video--fullscreen', isFullscreen);
            if (! isFullscreen) {
                var isPlaying = $(this).hasClass('vjs-playing');
                var $secondVideo = $(this).closest('.cc-image__video').siblings('.cc-image__video:visible');
                if ($secondVideo.length) {
                    // sync videos progress and switch if playing
                    var video1 = $('video', $(this)).get(0);
                    var video2 = $('video', $secondVideo).get(0);

                    syncVideos(video1, video2, isPlaying, true);
                }
            }
        });

        // sync videos progress and switch to second video if available, and if playing but only if not in fullscreen
        const mediaQuery = window.matchMedia('(orientation: landscape)');
        mediaQuery.addEventListener('change', function(e) {
            $('.experience-commerce_assets-CO_Image').each(function(){
                if ($('.cc-image__video:not(.cc-image__video--fullscreen)', $(this)).length === 2) {
                    var video1 = $('.cc-image__video video:not(:visible)', $(this)).get(0);
                    var video2 = $('.cc-image__video video:visible', $(this)).get(0);
                    // var isPlaying = $('.cc-image__video .video-js.vjs-playing', $(this));
                    var isPlaying = !! $(video1).closest('.video-js.vjs-playing').length;

                    syncVideos(video1, video2, isPlaying);
                }
            });
        });
    }
});

$(document).on('hide.bs.dropdown', '.js-dynamicContentSelect', function(e) {
    var languageValue = $(this).find('select').val();
    var url = $(document).find('input[name="urlRenderRegionAjax"]').val();
    var queryString = $(document).find('.cc-page').data('querystring');
    var container = $(document).find('.cc-dynamicContentItems .js-dynamicContentLanguage');
    var completeUrl = url + '?' + queryString;
    window.players = [];
    $.spinner().start();
    $.ajax({
        url: completeUrl,
        type: 'GET',
        data: {
            language: languageValue
        },
        success: function (data) {
            var html = $(data).filter('.cc-page').find('.cc-dynamicContentItems .js-dynamicContentLanguage');
            container.replaceWith(html);
            scrollAnimate($('.js-dynamicContentLanguage'));
            $(document).find('.js-dynamicContentLanguage').hide();
            if ($('.cc-dynamicContentItems').children().attr('language').length > 0) {
                $('.cc-dynamicContentItems').children().attr('language', languageValue);
            };
            $(document).find('.js-dynamicContentLanguage[data-language-code=' + languageValue + ']').show();
            var video = $('.cc-dynamicContentItems .js-dynamicContentLanguage').find('.cc-image__video video');
            if (video.length) {
                initializeCloudinaryPlayers();
            }
            $.spinner().stop();
        },
        error: function () {}

    });
});

$(document).on('click', '.js-order-by-date, .js-order-by-text', function() {
    var rows;
    var switching;
    var i;
    var x;
    var y;
    var shouldSwitch;
    var dir;
    var switchcount = 0;
    var table = $(document).find('.js-order-table')[0];
    var dataOrderElement = parseInt($(this).data('orderelement'));
    switching = true;
    dir = 'asc';
    while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 1; i < (rows.length - 1); i++) {
            shouldSwitch = false;
            x = rows[i].getElementsByTagName('TD')[dataOrderElement];
            y = rows[i + 1].getElementsByTagName('TD')[dataOrderElement];
            if (dataOrderElement !== 0) {
                if (dir === 'asc') {
                    if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                        shouldSwitch = true;
                        break;
                    }
                } else if (dir === 'desc') {
                    if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                        shouldSwitch = true;
                        break;
                    }
                }
            } else {
                if (dir === 'asc') {
                    if (new Date(x.dataset.datetocompare) > new Date(y.dataset.datetocompare)) {
                        shouldSwitch = true;
                        break;
                    }
                } else if (dir === 'desc') {
                    if (new Date(x.dataset.datetocompare) < new Date(y.dataset.datetocompare)) {
                        shouldSwitch = true;
                        break;
                    }
                }
            }
        }
        if (shouldSwitch) {
            rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
            switching = true;
            switchcount++;
        } else {
            if (switchcount === 0 && dir === 'asc') {
                dir = 'desc';
                switching = true;
            }
        }
    }
});
